export const VIEW_ROUTE_PATH = '/view'
export const DASHBOARD_ENTRY_ROUTE_NAME = 'home'

export default {
  VIEW_ROUTE_PATH,
  DASHBOARD_ENTRY_ROUTE_NAME
}
